module.exports = __webpack_public_path__ + "img/vdara3.83face5c.jpg";